import { translate } from '@utils/i18n';
const NS = 'features.iim_review.technician_ratings';
/* eslint-disable @typescript-eslint/naming-convention -- IpaTechnicianAssessmentRating values are snake_case */
const RATING_LABEL_DEFAULTS = {
    excellent: 'Excellent',
    good: 'Good',
    needs_review: 'Needs Review',
    needs_coaching: 'Needs Coaching'
};
export const TECHNICIAN_RATING_STATUS_COLOR = {
    excellent: 'green-500',
    good: 'green-500',
    needs_review: '--needs-review-dot',
    needs_coaching: 'red-500'
};
/* eslint-enable @typescript-eslint/naming-convention */
export function technicianRatingLabel(rating) {
    return translate(rating, { namespace: NS, defaultValue: RATING_LABEL_DEFAULTS[rating] });
}
